import React from "react";

function MinFullScreen(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
     width="1em"
      height="1em"
      viewBox="0 0 32 48"
      style={{fontSize: "1.5em"}}
      className={props.className}>
      <g id="Group_11788" data-name="Group 11788" transform="translate(-622 -895)">
        <g id="Group_11784" data-name="Group 11784" transform="translate(629 908)">
          <path id="Rectangle_382" data-name="Rectangle 382" d="M1,1V19H19V1H1M0,0H20V20H0Z" transform="translate(0 0)" fill="currentColor" />
        </g>
        <path id="Path_11811" data-name="Path 11811" d="M-6663-2035h-2v-5h-5v-2h7Z" transform="translate(-1404 7580) rotate(90)" fill="currentColor" />
        <path id="Path_11812" data-name="Path 11812" d="M-6663-2035h-2v-5h-5v-2h7Z" transform="translate(2682 -5744) rotate(-90)" fill="currentColor" />
      </g>
    </svg>

  );
}

export default MinFullScreen;